if (!customElements.get('cart-attributes')) {
  customElements.define(
    'cart-attributes',
    class CartAttributes extends HTMLElement {
      constructor() {
        super();

        // Initialize checkbox states on component load
        this.updateAllergyCheckboxStates();

        this.addEventListener(
          'input',
          debounce((event) => {
            // Update checkbox states whenever input changes
            this.updateAllergyCheckboxStates();

            // Collect all named inputs inside this element so multiple custom questions
            // are saved in a single update call.
            const inputs = this.querySelectorAll('input[name], textarea[name], select[name]');
            const bodyObj = {};
            const attributes = {};
            const checkboxGroups = {};

            inputs.forEach((input) => {
              const name = input.name;
              if (!name) return;

              const type = input.type;
              const isCheckbox = type === 'checkbox';
              const isRadio = type === 'radio';

              // For checkboxes, use the value or default to 'on'
              const value = isCheckbox ? (input.value || 'on') : input.value;

              // Keep legacy behavior for the native "note"
              if (name === 'note') {
                bodyObj.note = value;
                return;
              }

              // handle names like attributes[Key] and attributes[Key][]
              const attrMatch = name.match(/^attributes\[(.+?)\](?:\[\])?$/);
              const attrKey = attrMatch ? attrMatch[1] : name;

              if (isCheckbox) {
                // collect checked values for group; if none checked we will send '' to clear
                checkboxGroups[attrKey] = checkboxGroups[attrKey] || [];
                if (input.checked) checkboxGroups[attrKey].push(value);
                return;
              }

              if (isRadio) {
                // only the checked radio contributes
                if (input.checked) attributes[attrKey] = value;
                return;
              }

              // plain input/select/textarea
              attributes[attrKey] = value;
            });

            // serialize checkbox groups into a string (Shopify attributes are string values)
            Object.keys(checkboxGroups).forEach((key) => {
              const values = checkboxGroups[key];
              attributes[key] = values.length ? values.join(', ') : '';
            });

            if (Object.keys(attributes).length) bodyObj.attributes = attributes;

            // If there's nothing to send, bail out
            if (!Object.keys(bodyObj).length) return;

            const body = JSON.stringify(bodyObj);
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('attributes-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );

        // Handle details toggle for accordion behavior
        this.addEventListener('toggle', (event) => {
          const targetDetails = event.target;
          
          if (targetDetails.tagName === 'DETAILS' && targetDetails.open) {
            // Close all other details elements
            document.querySelectorAll('details[open]').forEach((openDetails) => {
              if (openDetails !== targetDetails) {
                openDetails.open = false;
              }
            });
          }
        }, true);
      }

      updateAllergyCheckboxStates() {
        // Find all allergy textareas and corresponding trace amounts checkboxes
        const allergyTextareas = this.querySelectorAll('textarea[name="attributes[Allergies]"]');
        const traceCheckboxes = this.querySelectorAll('input[name="attributes[Trace amounts ok]"][type="checkbox"]');
        
        allergyTextareas.forEach((textarea) => {
          // Find the corresponding checkbox in the same container or section
          let traceCheckbox = null;
          
          // First try to find checkbox in the same parent container
          const parentContainer = textarea.closest('.cart__fields, cart-attributes, [id*="Details-FoodAllergy"]');
          if (parentContainer) {
            traceCheckbox = parentContainer.querySelector('input[name="attributes[Trace amounts ok]"][type="checkbox"]');
          }
          
          // If not found in parent, look for any trace checkbox in the entire component
          if (!traceCheckbox && traceCheckboxes.length > 0) {
            traceCheckbox = traceCheckboxes[0];
          }
          
          if (traceCheckbox) {
            const hasText = textarea.value.trim().length > 0;
            traceCheckbox.disabled = !hasText;
            
            // If disabled, also uncheck the checkbox
            if (!hasText && traceCheckbox.checked) {
              traceCheckbox.checked = false;
              // Trigger a change event to update the cart
              traceCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
    }
  );
}
